import type { CurrencyCode, Wallet } from '../../types';
import { MOCK_WALLETS } from '../../lib/mockData';
import { makeId, request } from '../api/client';

let wallets = [...MOCK_WALLETS];

export const walletService = {
  list() {
    return request('/wallets', () => wallets);
  },

  get(id: string) {
    return request(`/wallets/${id}`, () => wallets.find((w) => w.id === id));
  },

  create(label: string, currency: CurrencyCode, type: 'fiat' | 'crypto') {
    return request('/wallets', () => {
      const wallet: Wallet = { id: makeId('w'), label, currency, balance: 0, type, changePct: 0 };
      wallets = [...wallets, wallet];
      return wallet;
    });
  },

  transfer(fromId: string, toId: string, amount: number) {
    return request('/wallets/transfer', () => {
      wallets = wallets.map((w) => {
        if (w.id === fromId) return { ...w, balance: w.balance - amount };
        if (w.id === toId) return { ...w, balance: w.balance + amount };
        return w;
      });
      return { fromId, toId, amount };
    }, { delay: 900 });
  },

  totalInUsd() {
    return request('/wallets/total', () => wallets.reduce((sum, w) => sum + (w.type === 'crypto' ? 0 : w.balance), 0));
  },
};
